import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { createTag, getAllUserTags, getPartAllocatedTags } from '../api/tags';
import { Tag } from '../@types';
import { PartAllocatedTagsKey, TagsKey } from '../configs/tags';

export const useAddTags = (): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await createTag(data);
      return response;
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [TagsKey]
      });
    }
  });
};

export const useGetAllTags = (id: number): UseQueryResult<[Tag]> => {
  return useQuery({
    queryKey: [TagsKey, id],
    queryFn: () => getAllUserTags(id)
  });
};

export const useGetPartAllocatedTags = (): UseQueryResult<[Tag]> => {
  return useQuery({
    queryKey: [PartAllocatedTagsKey],
    queryFn: () => getPartAllocatedTags()
  });
};